<div class="container animated fadeInRight">
  <app-lfsa-card [innTemplate]="Administrador" [titulo]="'Datos Administrador'" [efecto]="true"
    [colapseName]="'administrador'" [banderaColapse]='true'></app-lfsa-card>
  <ng-template #Administrador>
    <div class="row col-12">
      <div class="col-md-6">
        <h5><b>Nombres :</b>&nbsp;{{ dataUsuario.nombre }}</h5>
      </div>
      <div class="col-md-6">
        <h5><b>Apellidos :</b>&nbsp;{{  dataUsuario.apellido }}</h5>
      </div>
      <hr>
    </div>
  </ng-template>

  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/sstma/documentacion'] " class="btn btn-primary btn-block btn-lg">APROBAR/RECHAZAR DOCUMENTACIÓN IESS</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/sstma/aprobados'] " class="btn btn-primary btn-block btn-lg ">APROBADOS</button>
    </div>
  </div>
  <br>
  <div class="row">
    <div class="col-md-12">
      <button [routerLink]="['/emp/sstma/rechazados'] " class="btn btn-primary btn-block btn-lg ">RECHAZADOS</button>
    </div>
  </div>
  <br>
</div>